import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { ThemeProvider as StyledComponentThemeProvider } from 'styled-components'

import { CssBaseline } from '@mui/material'
import { StyledEngineProvider } from '@mui/material/styles'
import { StylesProvider, createGenerateClassName } from '@mui/styles'

import { store } from 'redux/store'

import App from './App'
import { GlobalStyles, themeVariables } from './themes'
import MuiThemeProvider from './themes/Provider'
import { THEME_NAME } from './utils/helperConfig'

;(function () {
    try {
        return require(`./themes/${THEME_NAME}/App.css`)
    } catch {
        return require('./themes/base/App.css')
    }
})()

const generateClassName = createGenerateClassName({
    productionPrefix: 'ultra-',
    disableGlobal: false,
})

const navigatorObject = window.navigator

ReactDOM.render(
    <div>
        {!navigatorObject?.cookieEnabled ? (
            <p>Please enable cookies in your browser settings.</p>
        ) : (
            <StylesProvider injectFirst generateClassName={generateClassName}>
                <StyledEngineProvider injectFirst>
                    <ReduxProvider store={store}>
                        <MuiThemeProvider>
                            <StyledComponentThemeProvider theme={themeVariables}>
                                <GlobalStyles />
                                <CssBaseline />
                                <BrowserRouter>
                                    <App />
                                </BrowserRouter>
                            </StyledComponentThemeProvider>
                        </MuiThemeProvider>
                    </ReduxProvider>
                </StyledEngineProvider>
            </StylesProvider>
        )}
    </div>,
    document.getElementById('root')
)
